export function getOrCreatePostSubmissionRequestId(requestIdRef) {
  if (!requestIdRef.current) {
    requestIdRef.current =
      window.crypto?.randomUUID?.() ??
      `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  return requestIdRef.current;
}

export function resetPostSubmissionRequestId(requestIdRef) {
  requestIdRef.current = "";
}
